import { CHECK_LOCATION } from "../../../Layers/constants";
import { OnloadLayerCallbackProps } from "./onload_layer_callbacks";

export const onload_layer_callbacks_mission_us = ({ layer, checks, patchLayer, config }: OnloadLayerCallbackProps): void => {
    const current_facility = layer.latest_location?.facility;

    if (!current_facility) {
        return;
    }

    // * Facilities that have at least one intake check (from checks with a location_id)
    const intakeChecksWithLocation = checks.filter((check) => check.location === CHECK_LOCATION.INTAKE && check.location_id);
    const facilitiesWithIntakeChecks = intakeChecksWithLocation
        .map((check) => config.get_facility_location(check.location_id as string)?.facility)
        .filter((facility) => facility);

    const currentFacilityHasIntakeChecks = facilitiesWithIntakeChecks.includes(current_facility);

    // * Just alter the local state for the Layer, no API call
    patchLayer("start_intake_check_disabled", currentFacilityHasIntakeChecks ? "1" : "0", false);
};
